export const iconFontAwesomeUsersPeopleClipboardUser = (
	<i className="fa-solid fa-clipboard-user"></i>
);
